import { useEffect } from "react";

/**
 * Custom hook to lock body scroll when a component (e.g., modal, mobile menu) is active.
 * @param {boolean} isLocked - Condition to lock the scroll.
 */
export const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    if (isLocked) {
      document.body.style.overflow = "hidden";
    }

    // Cleanup function to restore the original scroll behavior
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isLocked]);
};